var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("drag-selector-wrapper " + (_vm.disabled ? 'disabled' : '')),on:{"mousedown":_vm.handleMouseDown}},[_c('div',{staticClass:"drag-area-box",style:(_vm.selectAreaStyle)}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }